import { Component, Input } from "@angular/core";
import { Action } from "src/app/components/ui/actions/action";

@Component({
  selector: "snt-action-group",
  template: "",
  providers: [{ provide: Action, useExisting: ActionGroupComponent }],
  standalone: false
})
export class ActionGroupComponent extends Action {
  @Input()
  label: string | undefined;

  isGroup = true;
}
